// @ts-nocheck

import dash_api from '../../main/support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
const RECENT_ACTIVITY_PATH = '/v1/recent-activity';
const GetRecentActivity = new ReduxAsyncAction('GET_RECENT_ACTIVITY');
GetRecentActivity.registerRequest(() => {
  return dash_api.get(RECENT_ACTIVITY_PATH).then(({ data }) => data);
});
export const GET_RECENT_ACTIVITY = GetRecentActivity.constants;
export const getRecentActivity = GetRecentActivity.request;
